// import React, { Component } from "react";
// import { Link } from "react-router-dom";
// import * as HTTPServices from "../../../../../../api/HTTPServices";
// import CircularProgress from "@material-ui/core/CircularProgress";
// import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';

// class AddPrescription extends Component {
//   constructor(props) {
//     super(props);
//     this.customInputRef = React.createRef();
//     this.state = {
//       text: "",
//       file: "",
//       fileList: [],
//       loding: false,
//       showFiles: []
//     };

//     this.handleChange = this.handleChange.bind(this);
//     this.handleSubmit = this.handleSubmit.bind(this);
//   }

//   handleChange(event) {
//     switch (event.target.name) {
//       case "text":
//         this.setState({ text: event.target.value });
//         break;
//       case "file":
//         const filesArray = Array.from(event.target.files);
//         this.setState({
//           file: event.target.value,
//           fileList: filesArray,
//         });
//     }
//   }

//   handleSubmit(event) {
//     event.preventDefault();
//     if (this.state.fileList.length < 1) {
//       return;
//     }
//     var LiveObject = this;
//     LiveObject.setState({
//       loading: true,
//     });

//     const { AudienceID, VisitToken, AddFile, GetData } = this.props;
//     var Submit = document.getElementById("Submit");
//     Submit.disabled = true;
//     // Submit.innerText = "در حال ثبت ، لطفا صبر کنید...";

//     var formData = new FormData();
//     formData.append("message", this.state.text);
//     formData.append("audience", AudienceID);
//     formData.append("room_token", VisitToken);
//     formData.append("length", this.state.fileList.length);
//     formData.append("type", "prescriptionFile");

//     for (let i = 0; i < this.state.fileList.length; i++) {
//       if (this.state.file) {
//         formData.append(`file${i}`, this.state.fileList[i]);
//       } else {
//         formData.append("file", "");
//       }
//     }

//     const RequestService = HTTPServices.postMethod(
//       "FileSend",
//       formData,
//       "true"
//     );
//     RequestService.then(function (response) {

//       if (response) {
//         AddFile(response.message);
//         LiveObject.setState({
//           text: "",
//           loading: false,
//         });
//       } else {
//       }
//       LiveObject.setState({
//         text: "",
//         loading: false,
//       });
//     }).catch(function (error) {
//       LiveObject.setState({
//         loading: false,
//       });
//     });
//   }

//   render() {
//     return (
//       <div className="attach_new_file">
//         {/* <div className="fs_split_pane large_bottom_margin">
//           <form className="form-horizontal" onSubmit={this.handleSubmit}>
//             {this.state.loading ? (
//               <div
//                 style={{
//                   display: "flex",
//                   justifyContent: "center",
//                   alignItems: "center",
//                   alignItems: "center",
//                 }}
//               >
//                 <CircularProgress />
//               </div>
//             ) : (
//               <>
//                 <div className="box_input">
//                   <textarea
//                     name="text"
//                     className="form-control"
//                     placeholder="توضیحات کامل"
//                     value={this.state.text}
//                     onChange={this.handleChange}
//                   />
//                 </div>
//                 <div className="box_input">
//                   <label className="label_sbm" form="file">
//                     فایل ارسالی : تصویر / ویدیو / پیام صوتی
//                   </label>

//                   <input
//                     id="file"
//                     name="file"
//                     className="form-control"
//                     type="file"
//                     onChange={this.handleChange}
//                     multiple
//                   />

//                   <p className="help_text">
//                     فایل های قابل قبول:png , jpeg , jpg , gif , ogg , mp3 , mp4
//                   </p>
//                 </div>

//                 <div className="box_conferm">
//                   <button
//                     id="Submit"
//                     className="btn btn-success btn-block"
//                     type="submit"
//                   >
//                     ثبت دستورات جدید
//                   </button>
//                 </div>
//               </>
//             )}
//           </form>
//         </div> */}
//         <form className="upload-file-form-container" onSubmit={this.handleSubmit}>
//           برای ثبت مستند جدید لطفا اطلاعات بخش زیر را وارد کنید.
//           {/* <div className="desc-container">
//                   <textarea
//                     name="text"
//                     // className="form-control"
//                     placeholder="توضیحات کامل"
//                     value={this.state.text}
//                     onChange={this.handleChange}
//                   />
//                 </div> */}

//           <textarea
//             name="text"
//             className="desc-container"
//             placeholder="توضیحات کامل"
//             value={this.state.text}
//             onChange={this.handleChange}
//           />

//           <div className='files-container'>
//             {this.state.fileList && this.state.fileList.map((data, index) =>
//               <div className="choose-file-container" >
//                 <img src={URL.createObjectURL(data)} />
//               </div>
//             )}
//             <div className="choose-file-container" onClick={() => this.customInputRef.current.click()}>
//               <DriveFolderUploadIcon sx={{ fontSize: "40px", margin: "0px" }} />
//               <h6>اپلود فایل</h6>
//             </div>
//           </div>
//           <input
//             ref={this.customInputRef}
//             id="file"
//             name="file"
//             style={{ display: 'none' }}
//             type="file"
//             onChange={this.handleChange}
//             multiple
//           />
//           <p className="help_text">
//             فایل های قابل قبول:png , jpeg , jpg , gif , ogg , mp3 , mp4 ,pdf
//           </p>
//           {this.state.loading ? (
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//                 alignItems: "center",
//                 flexDirection: 'column'
//               }}
//             >
//               <CircularProgress />
//               در حال ارسال فایل
//             </div>
//           ) : (
//             <div className="button">
//               <button
//                 id="Submit"
//                 className="btn btn-success btn-block"
//                 type="submit"
//               >
//                 ثبت دستورات جدید
//               </button>
//             </div>)}
//         </form>
//       </div>
//     );
//   }
// }

// export default AddPrescription;

import React, { Component } from "react";
import * as HTTPServices from "../../../../../../api/HTTPServices";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Button, Box, Typography, IconButton } from "@mui/material";
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload'; import FolderIcon from '@mui/icons-material/Folder';
import * as Helper from "../../../../../../helpers/helper";
import DeleteIcon from '@mui/icons-material/Delete';
class AddAttachFile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      text: "",
      file: "",
      fileList: [],
      loading: false,
      disabled: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    switch (event.target.name) {
      case "text":
        this.setState({ text: event.target.value });
        break;
      case "file":
        const filesArray = Array.from(event.target.files);
   
        if (this.state.fileList.length < 5) {
          this.setState(
            {
              file: event.target.value,
              fileList: [...filesArray, ...this.state.fileList],
            }
          )
        } else {
          Helper.ErrorData("در مرحله حداکثر ۵ فایل قابل ارسال می باشد.");
        }

        break;
      default:
        break;
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    var LiveObject = this;
    LiveObject.setState({
      loading: true,
    });

    const { AudienceID, VisitToken, AddFile } = this.props;
    // var Submit = document.getElementById("Submit");
    // Submit.disabled = true;
    // Submit.innerText = "در حال ثبت ، لطفا صبر کنید...";

    var formData = new FormData();
    formData.append("message", this.state.text);
    formData.append("audience", AudienceID);
    formData.append("room_token", VisitToken);
    formData.append("length", this.state.fileList.length);
    formData.append("type", "dossierFile");
    for (let i = 0; i < this.state.fileList.length; i++) {
      if (this.state.file) {
        formData.append(`file${i}`, this.state.fileList[i]);
      } else {
        formData.append("file", "");
      }
    }

    // var Submit = document.getElementById("Submit");
    // Submit.disabled = true;

    const RequestService = HTTPServices.postMethod(
      "FileSend",
      formData,
      "true"
    );
    RequestService.then(function (response) {
      // Submit.disabled = false;

      if (response) {
        AddFile(response.data);
        LiveObject.setState({
          text: "",
          loading: false,
          // chats: [...LiveObject.state.chats, response.message],
          // selectedToReply: "",
          // showReplyDiv: false,
        });
      } else {
        // Submit.disabled = false;
        LiveObject.setState({
          loading: false,
        });
      }
    }).catch((error) => {
      console.log(error, 'error');
      // Submit.disabled = false;
      LiveObject.setState({
        loading: false,
      });
    });
  }

   handleClickDelete(files){
    const filesFilter=this.state.fileList.filter(item=>item.name!==files.name)
    this.setState({fileList:filesFilter})
  }


  render() {
    return (
      <div className="attach_new_file">
        <div className="fs_split_pane large_bottom_margin">
          <form className="form-horizontal" onSubmit={this.handleSubmit}>
            {this.state.loading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress />
              </div>
            ) : (
              <>
                <div className="box_input">
                  <textarea
                    style={{ backgroundColor: "#eee", height: "10rem" }}
                    name="text"
                    className="form-control"
                    placeholder="توضیحات کامل"
                    value={this.state.text}
                    onChange={this.handleChange}
                  />
                </div>
                <div className="box_input" style={{ display: "flex", flexDirection: "column", gap: "0.5rem", justifyContent: "center", alignItems: "center" }}>
                  {/* <label className="label_sbm" form="file">
                    فایل ارسالی : تصویر
                  </label> */}
                  <label style={{
                    display: "flex", justifyContent: "center", textAlign: "center", marginX: "auto"
                  }}>
                    <input
                      style={{ display: "none" }}
                      multiple
                      id="file"
                      name="file"
                      className="form-control"
                      type="file"
                      disabled={this.state.disabled}
                      onChange={this.handleChange}
                      required
                      accept="image/jpg, image/jpeg, image/png, application/pdf"
                    />
                    <Button id="file" component="span" disabled={this.state.disabled} sx={{
                      backgroundColor: "#eee !important",
                      padding: "2rem !important",
                      height: "10rem",
                      width: "10rem",
                      borderRadius: "10px !important",
                      display: "flex",
                      flexDirection: "column",
                      gap: "0.5rem",
                      fontSize: "1.5rem !important",
                      color: "#7747c0 !important"
                    }}>
                      <DriveFolderUploadIcon sx={{ color: "#7747c0", fontSize: "2rem !important" }} />
                      آپلود فایل
                    </Button>
                  </label>
                  <p className="help_text" style={{ marginBottom: "0", display: "flex", flexDirection: "column" ,justifyContent:"center",textAlign:"center"}}>
                    فایل های قابل قبول:png , jpeg , jpg  ,pdf
                    <span sx={{color:"#de0036 !important"}}>
                    در هر مرحله حداکثر ۵ فایل قابل ارسال می باشد
                    </span>
                  </p>

                  {this.state.fileList.map(files => (
                    <Box key={files.name} sx={{
                      background: "#eee",
                      display: "flex",
                      borderRadius: "10px",
                      width: "100%",
                      paddingY: "1rem",
                      justifyContent: "space-between !important"
                    }}>
                      <Box sx={{ display: "flex", alignItems: "center", color: "#7747c0", width: "80%", marginX: "auto", gap: "1rem" ,justifyContent:"space-between"}}>
                        <Box sx={{display:"flex",alignItems:"center",gap:"0.5rem"}}>
                          <FolderIcon sx={{ marginTop: "0.25rem" }} />
                          <Typography>{files.name.slice(0, 10)}... .{files.name.split(".")[1]}</Typography>
                        </Box>
                        <IconButton onClick={()=>this.handleClickDelete(files)}><DeleteIcon sx={{color:"#7747c0"}}/></IconButton>
                      </Box>
                    </Box>
                  ))}
                </div>

                <div className="box_conferm" style={{
                  display: "flex", justifyContent: "center", textAlign: "center", marginX: "auto"

                }}>
                  <button
                    id="SubmitّItem"
                    className="button"
                    type="submit"
                  >
                    تایید و ارسال
                  </button>
                </div>
              </>
            )}
          </form>
        </div>
      </div>
    );
  }
}

export default AddAttachFile;
